module.exports = __webpack_public_path__ + "img/1514244672.9d3a4f75.jpg";